module.exports = __webpack_public_path__ + "img/demo.2a993cfd.png";